import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ShoppingBag } from "lucide-react";
import { CartDrawer } from "@/components/CartDrawer";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/product", label: "Eye Massager" },
  { to: "/shiatsu", label: "DeepRelief Massager™" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`transition-all duration-300 ${scrolled ? "bg-background/95 backdrop-blur-lg shadow-lg border-b border-border/50" : "bg-background"}`}>
      <nav className="container mx-auto flex items-center justify-between px-6 py-4 lg:px-12">
        <Link to="/" className="flex items-center gap-2.5">
          <div className="w-10 h-10 rounded-xl gradient-primary flex items-center justify-center shadow-glow">
            <span className="text-white font-bold text-base tracking-tight">L</span>
          </div>
          <div className="flex flex-col">
            <span className="font-serif text-xl text-foreground tracking-tight leading-none">Luminaease</span>
            <span className="text-[9px] font-semibold tracking-[0.25em] uppercase text-muted-foreground leading-none mt-0.5">Wellness Technology</span>
          </div>
        </Link>

        {/* Desktop */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium transition-colors hover:text-primary ${
                location.pathname === link.to ? "text-primary" : "text-muted-foreground"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <CartDrawer />
          <Link
            to="/product"
            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-semibold text-cta-foreground rounded-full gradient-cta hover:opacity-90 transition-opacity shadow-cta"
          >
            <ShoppingBag size={16} />
            Shop Now
          </Link>
        </div>

        {/* Mobile toggle */}
        <div className="flex items-center gap-3 md:hidden">
          <CartDrawer />
          <button onClick={() => setIsOpen(!isOpen)} className="text-foreground">
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {/* Mobile menu — CSS transition instead of framer-motion */}
      <div
        className={`md:hidden bg-background border-b border-border overflow-hidden transition-all duration-300 ${
          isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0 border-b-0"
        }`}
      >
        <div className="flex flex-col items-center gap-6 py-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setIsOpen(false)}
              className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors"
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/product"
            onClick={() => setIsOpen(false)}
            className="inline-flex items-center gap-2 px-8 py-3 text-sm font-semibold text-cta-foreground rounded-full gradient-cta shadow-cta"
          >
            <ShoppingBag size={16} />
            Shop Now
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Navbar;